import { render, staticRenderFns } from "./webServiceMarkup.vue?vue&type=template&id=5b533e61&scoped=true&"
import script from "./webServiceMarkup.vue?vue&type=script&lang=ts&"
export * from "./webServiceMarkup.vue?vue&type=script&lang=ts&"
import style1 from "./webServiceMarkup.vue?vue&type=style&index=1&id=5b533e61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b533e61",
  null
  
)

export default component.exports